// Kennzahlen der Dokumente-Widgets (Handoff Dokumente §6.1). Reine Funktionen.

import { hauptordnerAus, HAUPTORDNER, type HauptordnerKey } from './ordner';

/** Sicherheit, ab der ein Vorschlag als „hohe Sicherheit“ gilt (Regel-Treffer = 0,9, vorschlag.ts). */
export const MASSEN_ABLAGE_SCHWELLE = 0.9;
export const istHoheSicherheit = (confidence: number | string | null | undefined) => Number(confidence ?? 0) >= MASSEN_ABLAGE_SCHWELLE - 1e-9;

export interface SignaturKurz {
  status: string | null;
  unterzeichner: readonly { status?: string | null }[] | null;
  abgelegt_am?: string | null;
}

export function signaturKennzahlen(vorgaenge: readonly SignaturKurz[]) {
  const wartend = vorgaenge.filter(v => v.status === 'verschickt');
  const gesamt = wartend.reduce((s, v) => s + (v.unterzeichner?.length ?? 0), 0);
  const signiert = wartend.reduce((s, v) => s + (v.unterzeichner ?? []).filter(u => u.status === 'signiert').length, 0);
  return {
    entwuerfe: vorgaenge.filter(v => v.status === 'entwurf').length,
    wartend: wartend.length,
    abgeschlossen: vorgaenge.filter(v => v.status === 'abgeschlossen').length,
    nichtAbgelegt: vorgaenge.filter(v => v.status === 'abgeschlossen' && !v.abgelegt_am).length,
    signiert,
    gesamt,
    /** Ring: Anteil geleisteter Unterschriften; bei wartenden Vorgängen mindestens 6 % sichtbar */
    anteil: wartend.length ? Math.max(0.06, signiert / Math.max(1, gesamt)) : 0,
  };
}

export interface AktenDatei { objekt_id: string | null; ablage_pfad: string | null }

/** Interne Ablage im gemeinsamen Drive (z. B. „02_Intern/01_Rechnungen/…“) – liegt nicht im Objekt-Ordner. */
export const istInterneAblage = (pfad: string | null | undefined): boolean => /^\d\d_Intern(\/|$)/.test((pfad ?? '').trim());

/** Dateien in Objekt-Ordnern, je Hauptordner (ohne erkennbaren Hauptordner unter „sonstige“). Interne Ablage zählt nicht. */
export function aktenschrankKennzahlen(dateien: readonly AktenDatei[]) {
  const objektDateien = dateien.filter(d => d.objekt_id && !istInterneAblage(d.ablage_pfad));
  const je = Object.fromEntries(HAUPTORDNER.map(k => [k, 0])) as Record<HauptordnerKey, number>;
  let sonstige = 0;
  for (const d of objektDateien) {
    const k = hauptordnerAus(d.ablage_pfad);
    if (k) je[k] += 1; else sonstige += 1;
  }
  return { dateien: objektDateien.length, objekte: new Set(objektDateien.map(d => d.objekt_id)).size, je, sonstige };
}
